var React = require('react')
var createReactTimeout = require('./reactTimeout.js')

module.exports = createReactTimeout(React)



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-timeout/src/web.js
// module id = 1082
// module chunks = 0